import React from 'react'
import styled from 'styled-components'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import { Carousel } from 'react-responsive-carousel'
import Frame from '@assets/login/carousel/frame.png'
import Frame2 from '@assets/login/carousel/frame2.png'
import Frame3 from '@assets/login/carousel/frame3.png'
import Frame4 from '@assets/login/carousel/frame4.png'
import Frame5 from '@assets/login/carousel/frame5.png'
import Frame6 from '@assets/login/carousel/frame6.png'
import Frame7 from '@assets/login/carousel/frame7.png'
import Frame8 from '@assets/login/carousel/frame8.png'
import Frame9 from '@assets/login/carousel/frame9.png'
import { Devices, Spacings, Text } from '@styles'
import { strings } from '@constants'

const CarouselWaaper = styled(Carousel)`
	.carousel .control-dots .dot.selected,
	.carousel .control-dots .dot:hover {
		background: ${({ theme }) => theme.palette.text.red};
	}
	.carousel .control-dots .dot {
		background: ${({ theme }) => theme.palette.text.greydark};
	}
	.carousel.carousel-slider {
		height: 50vh;
	}
	.carousel .slider-wrapper.axis-horizontal .slider {
		height: 41vh;
	}
`

const MainWapper = styled.div`
	background: #ffffff;
	width: 100%;
	@media ${Devices.laptop} {
		box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.32);
		width: 60%;
	}
	border-radius: ${Spacings.SPACING_6B};
	overflow: hidden;
`
const ImageWapper = styled.img`
	width: 15rem !important;
	height: 10rem !important;
	object-fit: contain;
	margin-top: ${Spacings.SPACING_6B};
`
const TitleWapper = styled.div`
	font-size: ${Text.MEDIUM};
	text-align: center;
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.darkblack};
`
const ParagraphWapper = styled.div`
	font-size: ${Text.SMALL};
	text-align: center;
	max-width: 21rem;
	margin-top: ${Spacings.SPACING_6};
	color: ${({ theme }) => theme.palette.text.darkblack};
`
const CarouselContent = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
	@media ${Devices.mobile} {
		justify-content: space-between;
	}
`
const ContentWapper = styled.div``

const carouselContent = [
	{
		img: Frame,
		title: strings('fastest_response_time'),
		paragraph: strings('carousel_helping_buyers'),
	},
	{
		img: Frame2,
		title: strings('facility_flexible_payments'),
		paragraph: strings('carousel_get_access'),
	},
	{
		img: Frame3,
		title: strings('verified_suppliers'),
		paragraph: strings('carousel_verified_network'),
	},
	{
		img: Frame4,
		title: strings('fastest_response_time'),
		paragraph: strings('carousel_helping_buyers'),
	},
	{
		img: Frame5,
		title: strings('best_prices'),
		paragraph: strings('carousel_get_ahead'),
	},
	{ img: Frame6, title: strings('digital_experience'), paragraph: strings('carousel_view_product') },
	{
		img: Frame7,
		title: strings('logistics_support'),
		paragraph: strings('carousel_guaranteed_time_delivery'),
	},
	{
		img: Frame8,
		title: strings(['100', '%', 'visibility']),
		paragraph: strings('carousel_see_quotations'),
	},
	{
		img: Frame9,
		title: strings('one_stop_solution'),
		paragraph: strings('carousel_source_through'),
	},
]

const CarouselComponent = () => {
	return (
		<MainWapper>
			<CarouselWaaper
				infiniteLoop={true}
				autoPlay={true}
				showArrows={false}
				showStatus={false}
				showThumbs={false}
				stopOnHover={true}
				showIndicators={true}
				interval={1500}
			>
				{carouselContent.map((item, index) => (
					<CarouselContent key={index}>
						<ImageWapper src={item?.img} />
						<ContentWapper>
							<TitleWapper>{item?.title}</TitleWapper>
							<ParagraphWapper>{item?.paragraph}</ParagraphWapper>
						</ContentWapper>
					</CarouselContent>
				))}
			</CarouselWaaper>
		</MainWapper>
	)
}

export default CarouselComponent
